/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const propTypes = {
  loadPagination: PropTypes.func,
  totalPages: PropTypes.number
};

const defaultProps = {
  totalPages: 0
};

const Pagination = ({
  totalPages,
  loadPagination
}) => {
  return totalPages >= 2 && (
    <PaginationWrapper>
      <PaginationList>
        {
          loadPagination()
        }
      </PaginationList>
    </PaginationWrapper>
  );
};

const PaginationWrapper = styled.div`
  max-width: fit-content;
  margin: 0 auto;
  padding-bottom: 5rem;
`;

const PaginationList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

export default Pagination;
